import React from "react";
import { useIntl } from "react-intl";
import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";

interface LoadingProps {
  show?: boolean;
  children?: any;
}

const DrawerLoading = ({ show, children }: LoadingProps) => {
  const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;
  const intl = useIntl();
  if (show) {
    return (
      <div data-testid="loading-container" style={{ alignItems: "center", justifyContent: "center", height: "calc(100% - 60px)", width: "100%", display: "flex" }}>
        <Spin indicator={antIcon} tip={intl.formatMessage({ id: "loading" })} size="large" />
      </div>
    );
  } else {
    return children;
  }
};

DrawerLoading.defaultProps = {
  show: true,
};

export default DrawerLoading;
